/* src/app/global/components/global-settings-popup/global-settings-popup.component.scss */
:host {
  height: 400px;
}
.cw-horizontalline {
  border-color: var(--color-accent);
  height: 2px;
}
.settings-popup {
  min-width: 242px;
}
:host button {
  width: 100%;
}
::ng-deep .mat-mdc-dialog-container {
  background: var(--color-default-light);
}
/*# sourceMappingURL=global-settings-popup.component.css.map */
